export const CONTACTS = {
  START_FETCH_CONTACTS: 'FETCH_TASKS',
  UPDATING_CONTACTS: 'UPDATING_CONTACTS',
  END_FETCH_CONTACTS: 'END_FETCH_CONTACTS'
};
